import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken } from "views/utils/CallApi";
import { CtxAuth } from "views/utils/Contexts";
import * as mb from "views/common/MessageBox";
import { getTimeRange } from "views/utils/CommonFunc";

interface IFSchedule {
    scheduleNo: number,
    startDate: string,
    endDate: string,
    pattern_list: IFPattern[],
}
interface IFPattern {
    patternId: string,
    mondayFlg: number,
    tuesdayFlg: number,
    wednesdayFlg: number,
    thursdayFlg: number,
    fridayFlg: number,
    saturdayFlg: number,
    sundayFlg: number,
    holidayFlg: number,
    frame_list: IFFrame[],
}
interface IFFrame {
    frame_no: number,
    schedule_start_time: string,
    schedule_end_time: string
}

export function ScheduleList(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [scheduleList, setScheduleList] = useState<IFSchedule[]>([]);
    const [scheduleDate, setScheduleDate] = useState<Date>();
    const [btnNewDisabled, setBtnNewDisabled] = useState<boolean>(true);

    useEffect(function(){
        
        getApiDataWithToken('/management/schedule',
            {},
            cua.getToken(),
            
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:

                        //期間（スケジュール）
                        let tmpScheduleList: IFSchedule[] = [];
                        res.data.schedule_list.forEach(function(schedule:any){

                            //曜日枠（パターン）
                            let tmpPattern:IFPattern[] = [];
                            schedule.pattern_list.forEach(function(pattern:any){

                                //時間（フレーム）
                                let tmpFrame:IFFrame[] = [];
                                pattern.frame_list.forEach(function(frame:any){
                                    tmpFrame.push({
                                        frame_no: frame.frame_no,
                                        schedule_start_time: frame.schedule_start_time,
                                        schedule_end_time: frame.schedule_end_time
                                    })
                                });

                                tmpPattern.push({
                                    patternId: pattern.pattern_id,
                                    mondayFlg: pattern.monday_flg,
                                    tuesdayFlg: pattern.tuesday_flg,
                                    wednesdayFlg: pattern.wednesday_flg,
                                    thursdayFlg: pattern.thursday_flg,
                                    fridayFlg: pattern.friday_flg,
                                    saturdayFlg: pattern.saturday_flg,
                                    sundayFlg: pattern.sunday_flg,
                                    holidayFlg: pattern.holiday_flg,
                                    frame_list: tmpFrame,
                                });

                            });

                            tmpScheduleList.push({
                                scheduleNo: schedule.schedule_no,
                                startDate: schedule.start_date,
                                endDate: schedule.end_date,
                                pattern_list: tmpPattern,
                            });

                        });
                        setScheduleList(tmpScheduleList);
                        setScheduleDate(new Date(res.data.scheduled_date));
                        setBtnNewDisabled(false);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
 
    //---------------------------------------
    // 曜日表示用文字列を取得する
    //---------------------------------------
    function getWeekText(pattern:IFPattern):string{       
        let weekList =[];
        if(pattern.sundayFlg === 1){
            weekList.push("日");
        }
        if(pattern.mondayFlg === 1){
            weekList.push("月");
        }
        if(pattern.tuesdayFlg === 1){
            weekList.push("火");
        }
        if(pattern.wednesdayFlg === 1){
            weekList.push("水");
        }
        if(pattern.thursdayFlg === 1){
            weekList.push("木");
        }
        if(pattern.fridayFlg === 1){
            weekList.push("金"); 
        }
        if(pattern.saturdayFlg === 1){
            weekList.push("土");
        }
        if(pattern.holidayFlg === 1){
            weekList.push("祝");
        }
        return weekList.join("・");
    }

    //---------------------------------------
    // データ編集リンクの取得
    // 変更可能なデータかを判定し、対応したJSXタグを返す
    //---------------------------------------
    function getDataLink(schedule:IFSchedule){
        const sDate:Date = new Date(schedule.startDate);
        if (scheduleDate && ((sDate > scheduleDate) || !schedule.endDate)){
            //期間外の場合のみ変更リンクを生成
            return (
                <a href={"edit?schedule=" + schedule.scheduleNo}> {schedule.startDate} ～ {schedule.endDate}</a>
            )
        } else {
            return (
                <span>{schedule.startDate} ～ {schedule.endDate}</span>
            )
        }
    }

    //---------------------------------------
    // 新規登録ボタンクリック
    //---------------------------------------
    function clickNew(){
        //終了日が空のデータが存在する場合、新規登録不可
        let nullFlg = false;
        scheduleList.forEach(function(schedule){
            if (!schedule.endDate){
                setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"終了日が空のデータが存在する場合、新規登録はできません。先に該当のデータを更新してください。"});
                nullFlg = true;
                return;
            }
        });
        if (nullFlg){
            return;
        }
        window.location.href='edit';
    }

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs}/>
                <h2 className="settings-title-h2">スケジュール管理</h2>
                <div className="settings-wrap-short">
                    <div className="settings-block">
                        <h3 className="settings-title-h3">基本営業時間</h3>
                        <div className="settings-form">
                            <div className="form-row">
                                <button className="btn-secondary" onClick={clickNew} disabled={btnNewDisabled}>新規登録</button>
                            </div>
                            <div className="form-row-comment">
                                ※既に注文管理内の確定日時に使用されているスケジュールは変更できません。<br/>
                                ※終了日が空のデータが存在する場合、新規登録はできません。
                            </div>
                            <div className="form-row">
                                {scheduleList.map(function(schedule, sidx){
                                    return(
                                        <div key={sidx} className="schedule-item">
                                            <div className="schedule-term text-size-l">
                                                {getDataLink(schedule)}
                                            </div>
                                            {schedule.pattern_list.map(function(pattern, pIdx){
                                                return (
                                                    <div key={pIdx} className="schedule-item-content">
                                                        <div className="schedule-day">{getWeekText(pattern)}</div>
                                                        <ul className="schedule-time-list">
                                                            {pattern.frame_list.map(function(frame, fIdx){
                                                                return(
                                                                    <li key={fIdx} className="schedule-time">
                                                                        {getTimeRange(frame.schedule_start_time, frame.schedule_end_time)}
                                                                    </li> 
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AdminFrame>
    )
}